import { loadLib } from "../utils/utlis";
export class DelioLabels {
  constructor() {
    globalThis.digitalData = globalThis.digitalData || {};
  }

  #setDeclaratives() {
    this.#setEtiquetasRingpool();
  }

  async loadDeclaratives() {
    this.#setDeclaratives();
  }

  #setEtiquetasRingpool() {
    //header
    let bttHeader = document.querySelector(".phone-cta")
    bttHeader.addEventListener(("click"),()=>{
      this.loadDRP({
        proveedor: "header",
        oferta:     null,
        oferta_proveedor:null,
        oferta_titulo: null,
        oferta_velocidad:null,
        oferta_precio:   null,
        level:    "header",  // 'provider' , 'offer', 'header' o 'footer'
      })
    })

    //footer
    let bttFooter = document.querySelector(".btn-advice")
    bttFooter.addEventListener(("click"),()=>{
      this.loadDRP({
        proveedor: "footer",
        oferta:     null,
        oferta_proveedor:null,
        oferta_titulo: null,
        oferta_velocidad:null,
        oferta_precio:   null,
        level:    "footer",  // 'provider' , 'offer', 'header' o 'footer'
      })
    })

    const mainButtons  = document.querySelectorAll('.btn-call');
    const extraButtons = document.querySelectorAll('.btn-llamanos');

    this.#bindButtons(mainButtons, 'provider');
    this.#bindButtons(extraButtons, 'offer');
  }

  #bindButtons(buttons, level) {
    buttons.forEach((element) => {
      element.addEventListener('click', () => {
        // Actualizamos globalThis.digitalData en el momento del clic
        globalThis.digitalData = {
          proveedor: element.dataset.provider || null,
          oferta:    element.dataset.offer    || null,
          oferta_proveedor: element.dataset.provider_oferta || null,
          oferta_titulo:    element.dataset.title_oferta    || null,
          oferta_velocidad: element.dataset.velocity_oferta || null,
          oferta_precio:    element.dataset.price_oferta    || null,
          level:    level,  // 'provider' o 'offer'
        };

        this.loadDRP(globalThis.digitalData);

        console.log('digitalData actualizado:', globalThis.digitalData);
      });
    });
  }


  async loadLabels() {
    this.#setDeclaratives();
  }


  getData(btt){
    btt.forEach((element)=>{
      element.addEventListener(("click"),()=>{
        let data = {
          provider: element.dataset.provider,
          offer:    element.dataset.offer,
          title:    element.dataset.title,
          velocity: element.dataset.velocity,
          price:    element.dataset.price,
        };
        return data;
      })
    })
  }
  

  loadDRP(data){
    let intervalDRP = setInterval(() => {
      if(typeof DRP == "function" && typeof DRP.loadLabels == "function" && typeof DFI?.labelsVarRingPool == "object"){
        clearInterval(intervalDRP);
        DFI.labelsVarRingPool.EDeclaratives = {...DFI.labelsVarRingPool.EDeclaratives  , ...data};
        DRP.loadLabels();
      }
    }, 500);
  }

  /**
   * Obtiene el ID del visitante de Piwik (Matomo) usando promesas.
   * Esta función es necesaria porque la librería de Piwik se carga de forma asíncrona.
   * @returns {Promise<string>} Una promesa que se resuelve con el ID del visitante.
   */
  getPiwikVisitorId() {
    return new Promise((resolve, reject) => {
      // Asegura que la cola de _paq esté inicializada
      var _paq = _paq || [];

      _paq.push(['getVisitorId', function (visitorId) {
        if (visitorId) {
          // La promesa se resuelve con el ID del visitante si está disponible
          resolve(visitorId);
        } else {
          // La promesa es rechazada si no se puede obtener el ID
          reject(new Error('No se pudo obtener el ID del visitante de Piwik.'));
        }
      }]);
    });
  }

  async loadDelioLibs(url, idTag) {
    try {
      const result = await loadLib(url, idTag);
      if (result) {
        let bttRingpool = document.querySelector(".phone-cta");
        bttRingpool.innerHTML = "Llámanos "+bttRingpool.href.split(":")[1];
        console.log("Scrip cargado correctamente :" + result);
      }
    } catch (error) {
      console.error("Error al cargar el script:", error);
    }
  }


}


